<div class="page-content-container">
  <app-datasafra-search-reports
    [filterFields]="filterConfig"
    [resultCount]="length >= 500 ? 500 : length"
    (filtersChange)="handleFilters($event)"
    (downloadClick)="downloadPage()"
  ></app-datasafra-search-reports>
  <app-reports-table-expand
    [dataSource]="dataSource"
    [isLoading]="(gridLoading$ | async) ?? false"
    [length]="length"
    [config]="tableConfig"
    [actions]="tableActions"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (rowToggle)="onRowToggle($event)"
    (handleSituationChipClick)="handleSituationChipClick($event)"
  >
    <ng-template #expandedDetailTemplate let-el>
      @let element = asTypedItem(el);
      <div class="requests-element-diagram">
        <div class="requests-detail-row">
          <span>
            <b># da solicitação:</b>
            {{ element.requestNumber }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Data da solicitação:</b>
            {{ formatDate(element.requestDate) }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Solicitante:</b>
            {{ element.requester }}
          </span>
        </div>
        @if (isAdmin()) {
          <div class="requests-detail-row">
            <span>
              <b>Cliente:</b>
              {{ element.client }}
            </span>
          </div>
        }
        <div class="requests-detail-row">
          <span>
            <b>Observação:</b>
            {{ element.error }}
          </span>
        </div>
      </div>
    </ng-template>
  </app-reports-table-expand>
</div>
